// const Bind = () => import(/* webpackChunkName: "bind" */'@/pages/customer/Bind');
import Bind from '@/pages/customer/Bind'
import Customer from '@/pages/customer/Customer'
import Dispatch from '@/pages/customer/Dispatch'
import Points from '@/pages/customer/Points'

export default [
  {
    name: 'bind',
    path: '/bind',
    component: Bind,
    meta: {
      title: '绑定手机号'
    }
  },
  {
    name: 'customer',
    path: '/customer',
    component: Customer,
    meta: {
      title: '客户信息'
    }
  },
  {
    name: 'dispatch',
    path: '/dispatch',
    component: Dispatch,
    meta: {
      title: '挂号分诊'
    }
  },
  {
    name: 'points',
    path: '/points',
    component: Points,
    meta: {
      title: '我的积分'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/customer.js